import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Button from '@mui/material/Button';
import MenuItem from '@mui/material/MenuItem';

const ResponsiveAppBar = () => {
  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const navLinks = [
    { label: 'Menu', href: '#menu' },
    { label: 'Visit', href: '#location' },
    { label: 'Contact', href: '#contact' },
  ];

  return (
    <AppBar position="fixed" elevation={0}>
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ display: 'flex', alignItems: 'center' }}>
          {/* Desktop left: subtle "90 PROOF" brand (no longer duplicated over the large hero text) */}
          <Box sx={{ display: { xs: 'none', md: 'flex' }, alignItems: 'center', mr: 3 }}>
            <a href="#top" className="linkDestyle">
              <Typography
                variant="h6"
                sx={{
                  fontWeight: 700,
                  letterSpacing: '2.5px',
                  fontSize: '1.05rem',
                  color: 'white'
                }}
              >
                90 PROOF
              </Typography>
            </a>
          </Box>

          {/* Desktop: nav links centered */}
          <Box
            sx={{
              display: { xs: 'none', md: 'flex' },
              flex: 1,
              justifyContent: 'center',
              alignItems: 'center',
              gap: 0.5
            }}
          >
            {navLinks.map((link) => (
              <a key={link.label} href={link.href} className="linkDestyle">
                <Button
                  sx={{
                    my: 1.5,
                    px: 2.2,
                    color: 'white',
                    fontWeight: 600,
                    letterSpacing: '1px',
                    '&:hover': { backgroundColor: 'rgba(197,162,111,0.12)', color: 'var(--accent)' }
                  }}
                >
                  {link.label}
                </Button>
              </a>
            ))}
          </Box>

          {/* Desktop ORDER button on the right */}
          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            <a
              href="https://www.doordash.com/store/90-proof-bar-grill-san-antonio-27592730/"
              target="_blank"
              rel="noreferrer"
              className="linkDestyle"
            >
              <Button
                sx={{
                  px: 2.5,
                  fontWeight: 700,
                  letterSpacing: '1.5px',
                  border: '1px solid var(--accent)',
                  color: 'var(--accent)',
                  '&:hover': { backgroundColor: 'var(--accent)', color: '#000' }
                }}
                size="small"
              >
                ORDER
              </Button>
            </a>
          </Box>

          {/* Mobile hamburger - right side */}
          <Box sx={{ display: { xs: 'flex', md: 'none' }, marginLeft: 'auto' }}>
            <IconButton
              size="large"
              aria-label="Open navigation menu"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
              keepMounted
              transformOrigin={{ vertical: 'top', horizontal: 'right' }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {navLinks.map((link) => (
                <a key={link.label} href={link.href} className="linkDestyle" onClick={handleCloseNavMenu}>
                  <MenuItem>
                    <div className="mobileFont">{link.label}</div>
                  </MenuItem>
                </a>
              ))}
              <a href="https://www.doordash.com/store/90-proof-bar-grill-san-antonio-27592730/" target="_blank" rel="noreferrer" className="linkDestyle" onClick={handleCloseNavMenu}>
                <MenuItem>
                  <div className="mobileFont" style={{ color: 'var(--accent)' }}>Order Online</div>
                </MenuItem>
              </a>
            </Menu>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
};
export default ResponsiveAppBar;